const getters = {
  getMe: state => state.me,
  getMeBasic: state => {
    return {
      userId: state.me.id,
      userName: state.me.firstname + ' ' + state.me.lastname,
      companyId: state.me.company.id
    }
  },
  getUsers: state => state.users,
  getUserName: state => state.me.email.split('@', 1)[0]


}

export default getters